import React, { useState, useRef, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { label } from 'constants/labels';
import ChatContainer from 'components/ChatBar/ChatContainer';
import { loadChat, chat } from 'lib/api';
import { ChatMessage } from 'lib/models';
import Button, { ButtonVariant } from 'components/Button';
import { useAppContext } from 'lib/state/TextProvider';

function makeClientSideChatMsg(msg: string, isUser: boolean): ChatMessage {
  return {
    text: msg,
    role: isUser ? "user" : "assistant",
    createdAt: new Date()
  };
}

function ChatTab() {
  const { state } = useAppContext();
  const inputBoxRef = useRef<HTMLInputElement|null>(null);
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  useEffect(() => {
    const loadPreviousChatMessages = async () => {
      if (state.userProfile) {
        const chatMessages = await loadChat(state.userProfile.rootChatUuid);
        setMessages(chatMessages);
      }
    };
    loadPreviousChatMessages();
  }, [state.userProfile, state.userProfile?.rootChatUuid]);

  const handleSubmitClick = async () => {
    if (!inputValue) {
      return;
    }

    const userMsg = inputValue;
    setInputValue('');

    const currMessages = [...messages, makeClientSideChatMsg(userMsg, true)];
    setMessages(currMessages);

    if (state.userProfile) {
      let accumulatedMsg = "";
      for await (const msgChunk of chat(state.userProfile.rootChatUuid, userMsg)) {
        accumulatedMsg += msgChunk;
        setMessages([...currMessages, makeClientSideChatMsg(accumulatedMsg, false)]);
      }
    }
  };

  const handleOnInputValueChange = (event: any) => {
    setInputValue(event.target.value);
  };

  const handleFormSubmit = (event: any) => {
    event.preventDefault();
    handleSubmitClick();
  };

  return (
    <div className="flex flex-col h-full w-full">
      <ChatContainer
        messages={messages}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        hideCollapseButton={true}
      />
      <div className="flex flex-col space-y-2 py-4">
        <div className="flex flex-row items-center">
          <form
            className="w-full overflow-x-hidden"
            onSubmit={handleFormSubmit}
          >
            <input
              type="text"
              ref={inputBoxRef}
              className="w-full bg-palette-5 focus:outline-none text-palette-1 placeholder-palette-4 resize-none py-2"
              placeholder={label('input_instructions_placeholder')}
              value={inputValue}
              onChange={handleOnInputValueChange}
            />
          </form>
        </div>
        <div className="w-full flex flex-row justify-end">
          <Button
            variant={ButtonVariant.Flat}
            icon={<FaArrowUp/>}
            disabled={!inputValue}
            onClick={handleSubmitClick}
          />
        </div>
      </div>
    </div>
  );
}

export default ChatTab;
